import { useEffect, useState } from "react"
import { useTranslation } from "react-i18next"

interface BeforeInstallPromptEvent extends Event {
  prompt: () => Promise<{ outcome: "accepted" | "dismissed" }>
}

export function InstallPrompt() {
  const { t } = useTranslation()
  const [deferredPrompt, setDeferredPrompt] = useState<BeforeInstallPromptEvent | null>(null)
  const [dismissed, setDismissed] = useState(
    () => sessionStorage.getItem("install_prompt_dismissed") === "1",
  )

  useEffect(() => {
    function handlePrompt(event: Event) {
      event.preventDefault()
      setDeferredPrompt(event as BeforeInstallPromptEvent)
    }

    window.addEventListener("beforeinstallprompt", handlePrompt)
    return () => window.removeEventListener("beforeinstallprompt", handlePrompt)
  }, [])

  if (!deferredPrompt || dismissed) return null

  async function handleInstall() {
    if (!deferredPrompt) return
    const result = await deferredPrompt.prompt()
    if (result.outcome === "accepted") {
      setDeferredPrompt(null)
    }
  }

  function handleDismiss() {
    setDismissed(true)
    sessionStorage.setItem("install_prompt_dismissed", "1")
    setDeferredPrompt(null)
  }

  return (
    <div className="install-banner">
      <span>{t("pwa.installPrompt")}</span>
      <div className="button-row">
        <button className="primary-button" onClick={() => void handleInstall()} type="button">
          {t("pwa.install")}
        </button>
        <button className="ghost-button" onClick={handleDismiss} type="button">
          {t("pwa.notNow")}
        </button>
      </div>
    </div>
  )
}
